import { createFileRoute } from "@tanstack/react-router";

import { INCIDENT_TYPES_QUERY } from "@/features/settings/incident-types/graphql/incident-types";
import { IncidentTypes } from "@/features/settings/incident-types/incident-types";

export const Route = createFileRoute("/_authenticated/settings/incident-types/")({
  component: IncidentTypes,
  loader: async ({ context }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(INCIDENT_TYPES_QUERY, {}).toPromise();
    }
  },
});
